/**
 * @method reqIdleCallback
 * @param {Function} callback 回调
 * @param {Number} timeout 超时时间
 */
export function reqIdleCallback(callback, timeout) {
  //小程序下支持requestIdleCallback，但没有window，不能通过window.requestIdleCallback判断
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(callback, {
      timeout: timeout || 1000
    });
  } else {
    setTimeout(callback, 0);
  }
}

/**
 * 生成一个指定长度的随机字符串，用于生成UUID
 * @method getUUID
 * @param {Number} length 长度
 * @param {Number} current 
 * @returns {String}
 */
export function getUUID() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
  var current = arguments.length > 1 ? arguments[1] : undefined;
  current = current ? current : '';
  return length ? getUUID(--length, '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.charAt(Math.floor(Math.random() * 60)) + current) : current;
}

/**
 * 对象的1层merge
 * @method assign
 * @param {Object} o1 目标对象
 * @param {Object} o2 被merge的对象
 * @returns 
 */
export function assign(o1, o2) {
  for (var i in o2) {
    o1[i] = o2[i];
  }
  return o1;
}

/**
 * 判断对象是否是 object，由于 typeof object core-js 会做 polyfill，所以不能直接用 typeof 判断
 * @param {*} obj 
 * @returns 
 */
export function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

/**
 * 判断对象的 o1 是否已经在另一个对象中 o2 存在，如果值为对象，则需要递归判断
 * 比如 o1 = {a: 1}，o2 = {a: 1, b: 2}
 * @method isInObjectInclude
 * @param {Object} obj1 对象1
 * @param {Object} obj2 对象2
 * @returns {Boolean}
 */
export function isInObjectInclude(obj1, obj2) {
  if (obj1 === undefined || obj2 === undefined) {
    return false;
  }
  if (!isObject(obj1) || !isObject(obj2)) {
    return false;
  }
  for (var i in obj1) {
    if (isObject(obj1[i])) {
      if (!isInObjectInclude(obj1[i], obj2[i])) {
        return false;
      }
    } else if (obj1[i] !== obj2[i]) {
      return false;
    }
  }
  return true;
}

/**
 * 判断是否为 debug 环境
 * @returns 
 */
export function getIsDebug() {
  try {
    return location.href.indexOf('aes_debug') > -1;
  } catch (error) {
    return false;
  }
}